import {Box} from '@mui/material';
import {Sx} from 'app/types/common';
import React from 'react';

const validIconSrc = '/assets/img/billing-icons/coupon-ready-to-apply.svg';
const invalidIconSrc = '/assets/img/billing-icons/coupon-not-ready-to-apply.svg';

interface Props extends Sx {
  valid: boolean;
}

export function CouponIcon({sx, valid}: Props) {
  return (
    <Box
      sx={sx}
      component="img"
      src={valid ? validIconSrc : invalidIconSrc}
      height={34}
      width={42}
      alt={valid ? 'Coupon is ready' : 'Coupon is not ready'}
    />
  );
}
